module.exports = __webpack_public_path__ + "media/images/bg_reviews@2x-3e0b125d23eb912b8259432e64159ee5.jpg";